import { AUTH_ROUTES } from "../components/authRoutes";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../layout/LayoutSidebar";
import Header from "../layout/LayoutHeader";
import "./Layout.css";
import LogoutPopup from "../settingProfile/LogoutPopup";
import { useAuth } from "../context/AuthContext";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1200);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    setIsLoggingOut(true);

    try {
      await logout();
      setShowLogoutModal(false);
      navigate(AUTH_ROUTES.signIn, { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="layout-wrapper">
      <Sidebar
        isOpen={sidebarOpen}
        onLogoutClick={() => setShowLogoutModal(true)}
      />
      {/* Overlay for mobile */}
      {sidebarOpen && window.innerWidth < 1200 && (
        <div className="overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <div className={`main-content ${sidebarOpen ? "shifted" : ""}`}>
        <Header
          toggleSidebar={() => setSidebarOpen(prev => !prev)}
          isSidebarOpen={sidebarOpen}
        />

        <div className="page-content">{children}</div>
      </div>
      <LogoutPopup
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
        isLoading={isLoggingOut}
      />
       
    
    </div>
  );
};

export default Layout;
